<template>
  <div id="BoxMenu">

    <div style=" height: 40px;  position: absolute;  z-index: 2;  right: -85px;  top: 10px;">
      <button
        class="btn btn-outline-secondary"
        style="float: right;margin-right: 5px;"
        v-if="userLog"
        @click="logout"
      >{{ $t("message.logout") }}</button>
    </div>
    <div class="wrapper">
      <!-- PLIKI Z CENNIKIEM DETAL-->

      <!-- <template v-if="servisWorkPulsar || servisWorkMeanWell">
        <div class="box" style="width: 360px;  padding: 16px;">
          <div class="form" id="logForm" style="width:100%">

            <a v-if="version.pulsarNumer" :href="urlPriceListPulsar" target="_blank">
              <img src="../assets/pdf.png" style="width: 65px;  margin: 0px 0px 10px 0px;">
              <p style="color: #23497f;  text-align: center;  font-size: 16px; margin-bottom: 35px;">{{ $t("message.cennik_detal") }} {{version.pulsarSerwisNumer}}</p>
            </a>

            <a v-if="version.mwNumer" :href="urlPriceListMeanWell" target="_blank">
              <img src="../assets/pdf.png" style="width: 65px;  margin: 0px 0px 10px 0px;">
              <p style="color: #23497f;  text-align: center;  font-size: 16px;">{{ $t("message.cennik_detal_mw") }} {{ (version.servisWorkMeanWell) ? version.mwSerwisNumer : version.mwNumer}}</p>
            </a>

          </div>
        </div>
      </template> -->

      <template v-if="servisWorkPulsar">
        <div class="box" style="width: 360px;  padding: 94px;">
            <div style="width: 100%;  display: block;  position: absolute;  height: 100%; background: rgba(66, 66, 66, 0.8);">
              <span style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotateZ(10deg); font-size: 40px;color: white;  font-weight: bold;">{{$t("message.pricelist_update")}}</span>
              <span style="position: absolute;  bottom: 0px;  width: 100%;  color: white;  left: 0px;  font-size: 16px;  text-align: right;  padding-right: 12px;">{{$t("message.data_stop_service")}} {{ version.pulsarSerwisStop}}</span>
            </div>
            <div style="">
                <img src="../assets/logo.png" style="width: 235px;  margin: 0px 0px 20px 0px;">
                <p style="color: #23497f;  text-align: center;  font-size: 18px;">{{$t("message.cennik_pulsar")}}</p>
            </div>
        </div>
      </template>
      <template v-else>
        <router-link class="btnBox" :to="{ name: 'ContentPage', params: { pricelist: 'pulsar' }}">
        <div class="box">
            <div style="">
                <img src="../assets/logo.png" style="width: 235px;  margin: 0px 0px 20px 0px;">
                <p style="color: #23497f;  text-align: center;  font-size: 18px;">{{$t("message.cennik_pulsar")}}</p>
            </div>
        </div>
        </router-link>
      </template>

      <template v-if="servisWorkMeanWell">
        <div class="box" style="width: 360px;  padding: 94px;">
            <div style="width: 100%;  display: block;  position: absolute;  height: 100%; background: rgba(66, 66, 66, 0.8);">
              <span style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotateZ(10deg); font-size: 40px;color: white;  font-weight: bold;">{{$t("message.pricelist_update")}}</span>
              <span style="position: absolute;  bottom: 0px;  width: 100%;  color: white;  left: 0px;  font-size: 16px;  text-align: right;  padding-right: 12px;">{{$t("message.data_stop_service")}} {{ version.mwSerwisStop}}</span>
            </div>
            <div style="">
                <img src="../assets/logo_meanwell.jpg" style="width: 162px;  margin: 0px 0px 20px 0px;">
                <p style="color: #23497f;  text-align: center;  font-size: 18px;">{{$t("message.cennik_mw")}}</p>
            </div>
        </div>
      </template>
      <template v-else>
        <router-link class="btnBox" :to="{ name: 'ContentPage', params: { pricelist: 'mw' }}">
        <div class="box">
            <div style="">
                <img src="../assets/logo_meanwell.jpg" style="width: 162px;  margin: 0px 0px 20px 0px;">
                <p style="color: #23497f;  text-align: center;  font-size: 18px;">{{$t("message.cennik_mw")}}</p>
            </div>
        </div>
        </router-link>
      </template>

    </div>

    <!-- <div class="wrapper">

      <router-link class="btnBox" :to="{ name: 'obudowyClientAkcept', params: { page: 'ClientAkcept' }}">
        <div id="content-pdfs" style="width: 50%; margin: 5px;">
          <div class="form" id="logForm" style="height: 369px; padding:62px;">
              <img src="../assets/logo.png" style="width: 235px;  margin: 0px 0px 20px 0px;">
              <p style="color: #23497f;  text-align: center;  font-size: 18px;">Cennik Pulsar</p>
          </div>
        </div>
      </router-link>
      <router-link class="btnBox" :to="{ name: 'obudowyClientAkcept', params: { page: 'ClientAkcept' }}">
        <div id="content-pdfs" style="width: 50%; margin: 5px;">
          <div class="form" id="logForm" style="height: 369px; padding:62px;">
              <img src="../assets/logo_meanwell.jpg" style="width: 200px;  margin: 0px 0px 20px 0px;">
              <p style="color: #23497f;  text-align: center;  font-size: 18px;">Cennik Mean Well</p>
          </div>
        </div>
      </router-link>

    </div> -->

  </div>
</template>

<script>
import { version } from 'less';
import { mapGetters } from 'vuex';

export default {
  name: 'BoxMenuPriceList',
  // props: ['userData', 'roles'],
  data () {
    return {
      userLog: false
    }
  },
  // computed: {
  //   ...mapState('app', ['statystyki']),
  //   statistics_orders () {
  //     return Object.keys(this.statystyki).length
  //   }
  // },
  methods: {
    logout() {
      sessionStorage.clear();
      this.userLog = false;
      this.$router.push({ name: "LoginPage" });
    }
  },
  computed: {
     ...mapGetters('version', ['version']),
     servisWorkPulsar () {
      if (process.env.VUE_APP_Log_In) {
        return this.version.pulsarSerwis
      } else {
        return false
      }
     },
     servisWorkMeanWell () {
      if (process.env.VUE_APP_Log_In) {
        return this.version.mwSerwis
      } else {
        return false
      }
     },
     urlPriceListPulsar () {
      let lang = this.$i18n.locale;
      if (this.version) {
        if (this.version.pulsarNumer) {
          let verPulsar = (this.version.pulsarSerwis) ? ((this.version.pulsarSerwisNumer && this.version.pulsarSerwisNumer !== '')
            ? this.version.pulsarSerwisNumer : this.version.pulsarNumer) : this.version.pulsarNumer
          if (lang == 'pl') {
            return 'https://app.pulsar.pl/pulsar-files/Pulsar_Cennik_Detal_'+verPulsar+'.pdf'
          } else {
            return 'https://app.pulsar.pl/pulsar-files/Pulsar_Pricelist_'+verPulsar+'.pdf'
          }
        }
      }
     },
     urlPriceListMeanWell () {
      let lang = this.$i18n.locale;
      if (this.version) {
        if (this.version.pulsarNumer) {
          let verPulsar = (this.version.mwSerwis)
          ? ((this.version.mwSerwisNumer && this.version.mwSerwisNumer !== '') ? this.version.mwSerwisNumer : this.version.mwNumer) : this.version.mwNumer
          if (lang == 'pl') {
            return 'https://app.pulsar.pl/pulsar-files/Pulsar_MW_Cennik_'+verPulsar+'.pdf'
          } else {
            return 'https://app.pulsar.pl/pulsar-files/Pulsar_MW_Pricelist_'+verPulsar+'.pdf'
          }
        }
      }
     }
  },
  async mounted () {
    console.log('-- PriceList mounted --')
    // this.$store.dispatch('version/load_version',[])
    await this.$store.dispatch('version/load_version', [])
  },
  created () {
    console.log('--- created PriceListPage ---')

    // this.$store.dispatch('version/load_version', 'all')
    this.$store.commit('pricelist/REMOVE_PRODUCTS')

    let userSession = sessionStorage.getItem("userLog");

    if (userSession == null && process.env.VUE_APP_Log_In == true) {
      this.$router.push({ name: "LoginPage" });
      this.userLog = false;
    } else {
      this.userLog = true;
    }
  }
}
</script>


<style scoped>
/*
#login {
  width: 500px;
  margin: 0 auto;
  padding: 23px;
  background: #ddd;
  border-radius: 10px;
  box-shadow: 5px 5px;
}
*/
.wrapper {
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  gap: 20px;
  min-height: 100vh;
  flex-wrap: wrap;
  margin-top: 40px;
}

.box {
  flex: 0 1 300px;          /* szerokość bazowa, ale może się zmniejszyć */
  height: 300px;
  background: lightblue;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  background: #fff;
  text-align: center;
  box-shadow: 0 0 20px 0 rgba(0,0,0,.2),0 5px 5px 0 rgba(0,0,0,.24);
}

.btnBox {
  height: 360px;
  width: 360px;
  transition: transform 0.5s ease; /* płynna zmiana */
}
.btnBox:hover {
  transform: scale(1.05);
}

@import url(https://fonts.googleapis.com/css?family=Roboto:300);

div.form p {
  font-size: 14px;
  text-align: left;
  color: #999;
}

#errors {
  font-size: 14px;
  list-style: disclosure-closed;
  list-style-position: outside;
  margin: 0px;
  padding: 10px;
  list-style-position: inside;
}
#errors li {
  padding: 0px;
}

.login-page {
  display: flex;
  margin: auto;
  width: 850px;
  margin: 0px auto;
}

</style>



// WEBPACK FOOTER //
// src/components/PriceListPage.vue